<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="prologue" id="prog">
<h1 class="ct"><a class="page" id="p2"></a><a class="page" id="p3"></a><a class="xref" href="#/chihineline0006#rprog">Prologue</a></h1>
<p class="pf">Before going past this page of the book, we need to define a term. So, may I ask for a quick indulgence? Please, step outside for a walk. I don’t wish to be imperious, certainly not on our first meeting, so I won’t say how far you should walk, or for how long. Just, please, go for a walk.</p>
<p>As you walk, take note of anything and everything that comes into view that you consider to be a part of nature. You may think this a gratuitous exercise, that you already know what you’ll find, but I’ll wager you see something you haven’t noticed before, or for which you do not have a name. Oh, and don’t just look. Take note of what you hear, smell, and feel. You might even do some tasting (but don’t taste any red berries or mushrooms you find). Be quite inclusive about this, but enjoy yourself. Take physical notes if you like, but mental notes are fine for now.</p>
<p>We’ll talk again very soon.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hineline-0009.vue?305accb4